// import React, { useEffect, useState } from "react";
// import TextSnippetIcon from "@mui/icons-material/TextSnippet";
// import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
// import { Link } from "react-router-dom";
// import withRouter from "../withRouter.js";
// import Footer from "../Component/Footer.js";
// import Menu from "../Component/Menu.js";
// import Header from "../Component/Header.js";
// import { screens } from "../Common/Products.js";
// import Credentials, { transactionFrom } from "../Common/Credentials.js";
// import dashboardIcon from "../images/Icons/dashboard.png"
// import mastersIcom from "../images/Icons/generic.png"
// import transactionsIcon from "../images/Icons/transaction.png"
// import reportsIcon from "../images/Icons/annual-report.png"
// import { Backdrop } from "@mui/material";
// import "../NewUI/NewMenu.css";
// import Breadcrumb from "../NewUI/NewComponents/Breadcrumb.jsx";

// const InventoryMenu = () => {
//   const [hovered, setHovered] = useState(null);

//   useEffect(() => {
//     Credentials.setSelectedMenu("Inventory")
//   }, [])

//   return (
//     <div>
//       <Backdrop
//         sx={{
//           color: "#fff",
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//         }}
//         open={transactionFrom === null}
//       >
//         <div className="menu-backdrop-content">
//           <div className="d-flex justify-content-center">
//             <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
//           </div>
//           <div className="d-flex justify-content-center">
//             <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
//           </div>
//         </div>
//       </Backdrop>
      
//       <Header />
//       <Menu />
      
//       <section className="content-wrapper">
//         <div className="menu-container">
//           <div className="menu-card">
//             <div className="menu-header">
//               {/* Modern Breadcrumb Navigation */}
//               <Breadcrumb breadcrumbs={[{name:"Home",path:"/index"},{name:"Inventory",path:null}]}/>

//               <div className="h-max border-slate-300 bg-white  p-4 rounded-lg menu-content">
//                 <ul className="menu-nav-list">
//                   <li className="menu-nav-item">
//                     <Link
//                       to={{ pathname: "/index" }}
//                       state={{ message: "" }}
//                       className="menu-nav-link"
//                     >
//                       <img className="menu-nav-icon" width="25" src={dashboardIcon} />
//                       <div className="mt-1">Dashboard</div>
//                     </Link>
//                   </li>
//                 </ul>
                
//                 <div className="menu-sections-container">
//                   {screens.includes("Inventory Masters") ? (
//                     <div className="menu-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon-masters" src={mastersIcom} />
//                         <span className="menu-section-title-text">Masters</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/category" }}
//                             state={{ message: "" }}
//                           >
//                             Category
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/uom" }}
//                             state={{ message: "" }}
//                           >
//                             UOM
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/brand" }}
//                             state={{ message: "" }}
//                           >
//                             Brand
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/size" }}
//                             state={{ message: "" }}
//                           >
//                             Size
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/colour" }}
//                             state={{ message: "" }}
//                           >
//                             Colour
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   ) : ""}

//                   {(screens.includes("Items") || screens.includes("Services") || screens.includes("Price") || screens.includes("Stock") || screens.includes("Stock Issue")) ? (
//                     <div className="menu-section menu-transactions-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon" width="20" src={transactionsIcon} />
//                         <span className="menu-section-title-text">Transactions</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         {screens.includes("Items") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/items" }}
//                               state={{ message: "" }}
//                             >
//                               Items/Products
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Services") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/services" }}
//                               state={{ message: "" }}
//                             >
//                               Services
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Price") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/cost" }}
//                               state={{ message: "" }}
//                             >
//                               Price
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Stock") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/stocks" }}
//                               state={{ message: "" }}
//                             >
//                               Stock
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Stock Issue") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/stockissue" }}
//                               state={{ message: "" }}
//                             >
//                               Stock Issue
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {(screens.includes("Damage") || screens.includes("Losses")) ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/losses" }}
//                               state={{ message: "" }}
//                             >
//                               Losses
//                             </Link>
//                           </li>
//                         ) : ""}
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/internalconsumption" }}
//                             state={{ message: "" }}
//                           >
//                             Internal Consumption
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   ) : ""}

//                   {screens.includes("Inventory Reports") ? (
//                     <div className="menu-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon-reports" src={reportsIcon} />
//                         <span className="menu-section-title-text">Reports</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/inventoryreport" }}
//                             state={{ message: "" }}
//                           >
//                             Inventory Report
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/stockreport" }}
//                             state={{ message: "" }}
//                           >
//                             Stock Report
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/damagereport" }}
//                             state={{ message: "" }}
//                           >
//                             Damage Report
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/consolidatereport" }}
//                             state={{ message: "" }}
//                           >
//                             Consolidate Report
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/consumptionreport" }}
//                             state={{ message: "" }}
//                           >
//                             Consumption Report
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/stocktransactionsreport" }}
//                             state={{ message: "" }}
//                           >
//                             Inventory Ledger
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   ) : ""}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default withRouter(InventoryMenu);


import React from 'react';
import { 
  FolderLock, 
  ArrowRightLeft, 
  FileText,
  ChevronRight,
  Blocks,
  Ruler,
  Tag,
  Palette,
  Layers,
  ShoppingBag,
  Wrench,
  DollarSign,
  Boxes,
  ClipboardCopy,
  AlertTriangle,
  FolderSync,
  TrendingDown,
  Warehouse
} from 'lucide-react';
import path from 'path-browserify';
import withRouter from '../withRouter';
import Footer from '../Component/Footer';
import { Backdrop } from '@mui/material';
import Header from '../Component/Header';
import Menu from '../Component/Menu';
import { theme, transactionFrom } from '../Common/Credentials';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from '../NewUI/NewComponents/Breadcrumb';
import { use } from 'react';
import Sidebar from '../Component/Sidebar';
import Layout from '../Component/Layout';

const InventoryMenu = () => {
  const navigate = useNavigate();
  // Structure mapping matching the image exactly
  const newsections = [
    {
      title: 'Masters',
      subtitle: 'Core operational definitions',
      icon: FolderLock,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
      items: [
        { id: 'category', label: 'Category', desc: 'Product groups & departments', icon: Layers, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-purple-50 hover:tw-bg-purple-100 text-purple-700', path: '/category', brandColor: theme === "classic" ? '#4d4d4d' : '#7C3AED' },
        { id: 'uom', label: 'UOM', desc: 'Units of measurement config', icon: Ruler, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 text-indigo-700', path: '/uom', brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1' },
        { id: 'brand', label: 'Brand', desc: 'Manufacturer & label registries', icon: Tag, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:tw-bg-blue-100 text-blue-700', path: '/brand', brandColor: theme === "classic" ? '#4d4d4d' : '#3B82F6' },
        { id: 'size', label: 'Size', desc: 'Dimensions, capacities, scales', icon: Blocks, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 hover:tw-bg-rose-100 text-rose-700', path: '/size', brandColor: theme === "classic" ? '#4d4d4d' : '#F43F5E' },
        { id: 'colour', label: 'Colour', desc: 'Color classification references', icon: Palette, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 text-emerald-700', path: '/colour', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' },
      ]
    },
    {
      title: 'Transactions',
      subtitle: 'Daily inventory ledger runs',
      icon: ArrowRightLeft,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-100 tw-text-blue-600 tw-border-blue-200',
      items: [
        { id: 'items-products', label: 'Items/Products', desc: 'Physical asset registry', icon: ShoppingBag, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:tw-bg-blue-100 text-blue-700', path: '/items', brandColor: theme === "classic" ? '#4d4d4d' : '#3B82F6' },
        { id: 'services', label: 'Services', desc: 'Professional service rates', icon: Wrench, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-cyan-50 hover:tw-bg-cyan-100 text-cyan-700', path: '/services', brandColor: theme === "classic" ? '#4d4d4d' : '#06B6D4' },
        { id: 'price', label: 'Price', desc: 'Cost & selling active margins', icon: DollarSign, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 text-emerald-700', path: '/cost', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' },
        { id: 'stock', label: 'Stock', desc: 'Warehouse bin distribution', icon: Boxes, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 text-amber-700', path: '/stocks', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' },
        { id: 'stock-issue', label: 'Stock Issue', desc: 'Departmental supply outputs', icon: ClipboardCopy, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-violet-50 hover:tw-bg-violet-100 text-violet-700', path: '/stockissue', brandColor: theme === "classic" ? '#4d4d4d' : '#8B5CF6' },
        { id: 'losses', label: 'Losses', desc: 'Damage, theft & leakage records', icon: AlertTriangle, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 hover:tw-bg-rose-100 text-rose-700', path: '/losses', brandColor: theme === "classic" ? '#4d4d4d' : '#F43F5E' },
        { id: 'internal-consumption', label: 'Internal Consumption', desc: 'Internal operational consume runs', icon: FolderSync, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-teal-50 hover:tw-bg-teal-100 text-teal-700', path: '/internalconsumption', brandColor: theme === "classic" ? '#4d4d4d' : '#14B8A6' },
      ]
    },
    {
      title: 'Reports',
      subtitle: 'Audits, ledgers, analytics',
      icon: FileText,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-100 tw-text-emerald-600 tw-border-emerald-200',
      items: [
        { id: 'inventory-report', label: 'Inventory Report', desc: 'Active item master catalog sheets', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 text-emerald-700', path: '/inventoryreport', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' },
        { id: 'stock-report', label: 'Stock Report', desc: 'Under-stock alerts & warehouse weights', icon: Warehouse, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-teal-50 hover:tw-bg-teal-100 text-teal-700', path: '/stockreport', brandColor: theme === "classic" ? '#4d4d4d' : '#14B8A6' },
        { id: 'damage-report', label: 'Damage Report', desc: 'Loss tally & expense summary reports', icon: TrendingDown, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 hover:tw-bg-rose-100 text-rose-700', path: '/damagereport', brandColor: theme === "classic" ? '#4d4d4d' : '#F43F5E' },
        { id: 'consolidate-report', label: 'Consolidate Report', desc: 'Unified cost-valuation balance stats', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 text-amber-700', path: '/consolidatereport', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' },
        { id: 'consumption-report', label: 'Consumption Report', desc: 'Department-wise draw distributions', icon: ClipboardCopy, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-purple-50 hover:tw-bg-purple-100 text-purple-700', path: '/consumptionreport', brandColor: theme === "classic" ? '#4d4d4d' : '#8B5CF6' },
        { id: 'inventory-ledger', label: 'Inventory Ledger', desc: 'Chronological transaction trail', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 text-indigo-700', path: '/stocktransactionsreport', brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1' },
      ]
    }
  ]


  const onSelectItem = (path) => {
    navigate(path);
  }

  return (
        <div className=''>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={transactionFrom === null}
      >
        <div className="menu-backdrop-content">
          <div className="d-flex justify-content-center">
            <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
          </div>
          <div className="d-flex justify-content-center">
            <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
          </div>
        </div>
      </Backdrop>
      
      {/* <Header /> */}
      {/* <Menu /> */}
      {/* <Sidebar/> */}
<Layout menu={"inventory"}>
         
         <div className="menu-container tw-mx-2">
          <div
  id="dashboard-content-area"
  className="tw-flex-1  tw-overflow-y-auto tw-bg-transparent tw-pb-4 tw-ml-2"
>
  {/* Upper Hero Grid */}
  <div
    id="hero-welcome-banner"
    className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-items-center tw-bg-white tw-rounded-3xl tw-px-8 tw-py-2 tw-border tw-border-slate-200/80 tw-shadow-[0_12px_40px_rgba(0,0,0,0.02)] tw-mb-4 tw-relative tw-overflow-hidden"
  >

     {/* Background Blur Shapes */}
        <div className="tw-absolute tw-top-0 tw-right-0 tw-w-96 tw-h-96 tw-bg-blue-50/40 tw-rounded-full tw-blur-3xl -tw-z-10 tw-translate-x-12 -tw-translate-y-12"></div>
    
        <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-64 tw-h-64 tw-bg-indigo-50/30 tw-rounded-full tw-blur-3xl -tw-z-10 -tw-translate-x-12 tw-translate-y-12"></div>
    
        {/* Left Content */}
        <div className="md:tw-col-span-2 tw-text-left tw-space-y-2">
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/index"},{name:"Masters",path:null}]}/>
          <h1 className="tw-text-4xl tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-pt-1">
            Inventory
          </h1>
    
          <p className="tw-text-slate-500 tw-font-medium tw-text-[10px] md:tw-text-xs tw-max-w-lg">
          Manage your inventory with ease and efficiency. Click any core definition,
        daily transaction, or automated audit sheet to administer real-time warehouse states.
          </p>
        </div>

    {/* Right SVG Illustration */}
    <div className="tw-flex tw-justify-center md:tw-justify-end tw-mt-4 md:tw-mt-0 tw-relative tw-group">
      <div
        className="tw-w-32 tw-h-32 tw-relative tw-flex tw-items-center tw-justify-center"
        style={{ animationDuration: '4s' }}
      >
        <div className="tw-absolute tw-bottom-4 tw-w-32 tw-h-4 tw-bg-slate-300/30 tw-rounded-full tw-blur-md"></div>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          className="tw-w-32 tw-h-32 tw-drop-shadow-xl"
        >
          <defs>
            <linearGradient id="boxTop" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#C3DAFE" />
              <stop offset="100%" stopColor="#818CF8" />
            </linearGradient>

            <linearGradient id="boxLeft" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#6366F1" />
              <stop offset="100%" stopColor="#4F46E5" />
            </linearGradient>

            <linearGradient id="boxRight" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#4F46E5" />
              <stop offset="100%" stopColor="#3730A3" />
            </linearGradient>
          </defs>

          <g
            className="tw-animate-pulse"
            style={{ animationDuration: '3s' }}
          >
            <path
              d="M 256,120 L 290,102 L 256,84 L 222,102 Z"
              fill="url(#boxTop)"
            />

            <path
              d="M 222,102 L 222,126 L 256,144 L 256,120 Z"
              fill="#6366F1"
            />

            <path
              d="M 256,120 L 256,144 L 290,126 L 290,102 Z"
              fill="#4F46E5"
            />
          </g>

          <g
            className="tw-animate-pulse"
            style={{ animationDuration: '2.4s' }}
          >
            <path
              d="M 360,190 L 380,180 L 360,170 L 340,180 Z"
              fill="#C3DAFE"
              opacity="0.8"
            />

            <path
              d="M 340,180 L 340,195 L 360,205 L 360,190 Z"
              fill="#818CF8"
              opacity="0.8"
            />

            <path
              d="M 360,190 L 360,205 L 380,195 L 380,180 Z"
              fill="#4F46E5"
              opacity="0.8"
            />
          </g>

          <path
            d="M 256,360 L 400,288 L 256,216 L 112,288 Z"
            fill="#3D291F"
          />

          <path
            d="M 256,216 L 316,130 L 196,130 Z"
            fill="#A18072"
          />

          <polygon
            points="256,324 350,277 256,230 162,277"
            fill="url(#boxTop)"
            opacity="0.4"
          />

          <path
            d="M 112,288 L 112,410 L 256,482 L 256,360 Z"
            fill="url(#boxLeft)"
          />

          <path
            d="M 256,360 L 256,482 L 400,410 L 400,288 Z"
            fill="url(#boxRight)"
          />

          <path
            d="M 112,288 L 23,288 L 112,360 Z"
            fill="#4F46E5"
          />

          <path
            d="M 400,288 L 489,288 L 400,360 Z"
            fill="#3730A3"
          />
        </svg>
      </div>
    </div>
  </div>

  {/* Main Grid */}
  <div
    id="erp-columns-grid"
    className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4"
  >


    {/* Menus */}
        {newsections.map((section) => (
     <div
      id="section-col-masters"
      className="tw-bg-white tw-rounded-3xl tw-border tw-border-slate-200/80 tw-p-6 tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)] tw-text-left tw-flex tw-flex-col hover:tw-shadow-lg tw-transition-shadow tw-duration-300"
    >
      <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6 tw-pb-4 tw-border-b tw-border-slate-100">
        <div
          className={`tw-w-12 tw-h-12 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-border ${section.iconColor}`}
        >
          <FolderLock size={22} />
        </div>

        <div>
          <h2 className="tw-text-lg tw-font-extrabold tw-text-slate-800">
            {section.title}
          </h2>

          <p className="tw-text-xs tw-text-slate-400 tw-font-medium tw-my-0">
            {section.subtitle}
          </p>
        </div>
      </div>

      <div className="tw-space-y-3 tw-flex-1">
        {section.items.map((item) => {
          const Icon = item.icon;

          return (
            <button
              id={`subsection-btn-${item.id}`}
              key={item.id}
              onClick={() => onSelectItem(item.path)}
              className="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white hover:tw-bg-slate-50 hover:tw-border-slate-300/60 hover:tw-shadow-sm tw-transition-all tw-group tw-duration-200 tw-cursor-pointer tw-text-left"
            >
              <div className="tw-flex tw-items-center tw-gap-3.5">
                <div
                  className={`tw-w-9 tw-h-9 tw-rounded-xl tw-flex tw-items-center tw-justify-center ${item.brandStyle} tw-shrink-0`}
                >
                  <Icon size={16} color={item.brandColor} />
                </div>

                <div>
                  <h4 className="tw-text-sm tw-font-bold tw-text-slate-700 group-hover:tw-text-blue-600 tw-transition-colors">
                    {item.label}
                  </h4>

                  <p className="tw-text-[10px] tw-text-slate-400 tw-font-medium tw-mt-0.5 tw-mb-0">
                    {item.desc}
                  </p>
                </div>
              </div>

              <ChevronRight
                size={16}
                className="tw-text-slate-300 group-hover:tw-text-blue-500 group-hover:tw-translate-x-0.5 tw-transition-all"
              />
            </button>
          );
        })}
      </div>
    </div>))}
  </div>

</div>
          </div>
          </Layout>
      </div>
  );
}
export default withRouter(InventoryMenu);